module.exports = __webpack_public_path__ + "static/img/secure-notes.1ca581e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img-text/images/secure-notes.svg
// module id = se6s
// module chunks = 26